import AppLangMutations from "./mutations";
import AppLangActions from "./actions.js";
import AppLangGetters from "./getters.js";

export default {
  namespaced: true,
  state: {
    // START:: printableGE DATA
    printable_admin_dashboard_printablege: localStorage.getItem(
      "printable_admin_dashboard_printablege"
    ),
    // END:: printableGE DATA
  },
  mutations: AppLangMutations,
  actions: AppLangActions,
  getters: AppLangGetters,
};
